import auth_requests from './requests/auth'
import maarima_requests from './requests/maarima'
import resource_requests from './requests/resources'
import test_requests from './requests/datatester'
import bug_requests from './requests/bugs'
import healthCheck_request from './requests/connection'
import user_requests from './requests/maarima/users'
import axios from 'axios'
import env from '../store/base/config/env'
const qs = require('qs')

const baseUrl = env.VUE_APP_API_PATH

async function download(url, options) {
    var { responseType, filename, method, params, data } = options || {}
    let response = await api.request(url, {
        responseType: responseType || 'blob',
        params: params || {},
        method: method || 'get',
        data
    })
    if (!filename) {
        var headerValues = response.headers['content-disposition'].parseHeaderValues()
        filename = headerValues['filename'].split('filename=')[1].replaceAll('"', '')
    }

    var blob = new Blob([response.data])
    downloadBlob(blob, filename)
}

function downloadJsonToCsv(jsonData, filename, parameters) {
    //If JSONData is not an object then JSON.parse will parse the JSON string in an Object
    var arrData = typeof jsonData != 'object' ? JSON.parse(jsonData) : jsonData
    var CSV = ''

    // Generate the Label/Header
    var csvHeader = ''
    for (var index in arrData[0]) {
        csvHeader += index + ','
    }
    csvHeader = csvHeader.slice(0, -1)
    // append Label row with line break
    CSV += csvHeader + '\r\n'

    // Body for each row
    for (var i = 0; i < arrData.length; i++) {
        var csvBody = ''

        for (var data in arrData[i]) {
            if (typeof arrData[i][data] == 'object') {
                csvBody += '"' + '",'
            } else {
                csvBody += '"' + arrData[i][data] + '",'
            }
        }
        csvBody.slice(0, csvBody.length - 1)

        CSV += csvBody + '\r\n'
    }

    // filename based on filter parameters
    var newFilename = ''

    Object.keys(parameters).forEach((key) => {
        var value = parameters[key]
        if (!value) {
            return
        }
        if (Array.isArray(value)) {
            value = value.join(',')
        } else if (value instanceof Date) {
            value = value.toISODateString()
        }
        newFilename += `${key}=${value}_`
    })

    newFilename = `${filename}_${newFilename.substring(0, newFilename.length - 1)}.csv`

    var csv = CSV
    var blob = new Blob([csv], { type: 'text/csv' })
    downloadBlob(blob, newFilename)
}

function downloadBlob(blob, filename) {
    const windowUrl = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = windowUrl
    link.setAttribute('download', filename)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
}

if (!baseUrl) {
    throw new Error('API integration requires env variable: VUE_APP_API_PATH')
}

const api = axios.create({
    baseURL: baseUrl,
    paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'index', skipNulls: true })
})

api.download = download
api.downloadBlob = downloadBlob
api.downloadJsonToCsv = downloadJsonToCsv
api.auth = auth_requests
Object.assign(api, maarima_requests)
api.maarima = maarima_requests
api.resources = resource_requests
api.test = test_requests
api.users = user_requests
api.bugs = bug_requests
api.connection = healthCheck_request
export default api
